import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import CookieBanner from "./components/CookieBanner";
import HomePage from "./pages/HomePage";
import LibraryPage from "./pages/LibraryPage";
import ComicDetailPage from "./pages/ComicDetailPage";
import ReaderPage from "./pages/ReaderPage";
import StatsPage from "./pages/StatsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage from "./pages/AdminPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutCancelPage from "./pages/CheckoutCancelPage";
import PublishPage from "./pages/PublishPage";
import ApplyPage from "./pages/ApplyPage";
import WriterDashboardPage from "./pages/WriterDashboardPage";
import { Toaster } from "./components/ui/sonner";

function ConditionalChrome({ children }) {
    const location = useLocation();
    const isReader = location.pathname.startsWith("/read/");
    return (
        <>
            {!isReader && <Navbar />}
            {children}
            {!isReader && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <ConditionalChrome>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/library" element={<LibraryPage />} />
                            <Route path="/comic/:slug" element={<ComicDetailPage />} />
                            <Route path="/read/:chapterId" element={<ReaderPage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                            <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
                            <Route path="/publish" element={<PublishPage />} />
                            <Route path="/apply" element={<ApplyPage />} />
                            <Route
                                path="/writer"
                                element={
                                    <ProtectedRoute writerOrAdmin>
                                        <WriterDashboardPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/stats"
                                element={
                                    <ProtectedRoute>
                                        <StatsPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <AdminPage />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </ConditionalChrome>
                    <CookieBanner />
                    <Toaster />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
